import React from 'react';


class Desktop extends React.Component{

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.offerType == "venue" && this.props.offerContent) {

      window.location = "https://playo.co/booking?venueId=" + this.props.offerContent;
    }
    if (this.props.offerType == "activity" && this.props.offerContent) {
      window.location = "https://playo.co/activity?activityId=" + this.props.offerContent;
    }
    if(this.props.offerType == "invite" || !this.props.offerContent){
       window.location = "https://playo.co/download";
    }
  }

  render(){


    return (

        <div className="jumbotron offer-detail-div lightFont">

          {/*<h5 className="offer_details">*/}

             {/*{ this.props.offerName}*/}

          {/*</h5>*/}


          { this.props.shareMsg?
            <h5 className="offer_details">
              <span className="detail_text">{this.props.shareMsg}</span>
           </h5>: <span/>
          }


          { this.props.coupon?
            <h5 className="offer_details">
              <span className="detail_text couponCode">{this.props.coupon} </span>
            </h5> : <span/>
          }

          <img src={this.props.imageUrl} className="offer_image" alt=""/>



        </div>
    )
  }
}




export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/desktop-all-component.js